import type { DailyPresetId } from 'components/filter/input/DateRangePicker/presets';

export const ARTICLE_VISIBILITY_PRESET_IDS: DailyPresetId[] = [
  'no_selection',
  'custom',
  'last_7_days',
  'last_14_days',
  'last_30_days',
  'last_6_months',
  'last_year',
];
